import React from 'react'
import { getDocumentIcon } from '@/lib/document-icons'
import { formatThreadActivity } from '@/lib/api/threads'
import { visibleMessageReferences } from '@/lib/session-scratch-path'
import type { DocumentReference } from '@/components/layout/chat-pane.types'

interface MessageTimestampProps {
  timestamp?: string | Date
}

export function MessageTimestamp({ timestamp }: MessageTimestampProps) {
  if (!timestamp) return null

  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) return null

  const absolute = date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })

  return (
    <div
      className="mt-0.5 text-xs tabular-nums text-muted-foreground/70"
      title={absolute}
    >
      {formatThreadActivity(date.toISOString())}
    </div>
  )
}

interface MessageReferencesProps {
  references?: DocumentReference[]
}

export function MessageReferences({ references }: MessageReferencesProps) {
  const visible = visibleMessageReferences(references)
  if (visible.length === 0) return null
  
  return (
    <div className="mt-2 pt-2 border-t border-border">
      <div className="text-xs text-muted-foreground mb-1">Referenced documents:</div>
      <div className="flex flex-wrap gap-1">
        {visible.map((ref) => (
          <div key={ref.id} className="flex items-center gap-1 px-2 py-1 rounded-md text-xs bg-muted/50 border border-border">
            {getDocumentIcon(ref.type, "h-3 w-3")}
            <span className="truncate max-w-[100px]">{ref.title}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

